import { createApp } from 'vue'

import BaseAlert from '@/src/vueComponent/BaseAlert.vue'
import QualityFeedbackSearch from '@/src/javascripts/quality_feedbacks/QualityFeedbackSearch.vue'

$(document).on('turbo:load turbo:render', () => {
  const qualityFeedbackIndex = document.querySelector('#quality-feedback-index')
  if (qualityFeedbackIndex && !qualityFeedbackIndex.__vue_app__) {
    createApp({ components: { BaseAlert, QualityFeedbackSearch } }).mount(qualityFeedbackIndex)
  }
})
